import { Box, Image, Checkbox, Tooltip, Text } from '@chakra-ui/react';

type Props = {
  paymentMethod: string;
  imageUrl: string;
  isDisabled: boolean;
  checked: boolean;
  tooltip?: string;
  subtext?: string;
  onChange: () => void;
};

const PaymentMethodCheckbox = ({
  paymentMethod,
  imageUrl,
  isDisabled,
  checked,
  tooltip,
  subtext,
  onChange,
}: Props): JSX.Element => {
  return (
    <Tooltip hasArrow label={tooltip} bg={'#606060'} p={2}>
      <Box
        display={'flex'}
        flexDirection={'row'}
        py={2}
        px={4}
        justifyContent={'space-between'}
        alignItems={'center'}
        border={checked ? '1px solid rgb(0, 0, 0)' : '1px solid #DFDEE2'}
        borderRadius={'6px'}
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        onClick={isDisabled ? undefined : onChange}
      >
        <Checkbox variant={'circular'} isChecked={checked} isDisabled={isDisabled} pointerEvents="none">
          <Box>
            {paymentMethod}
            {subtext && (
              <Text fontSize="xs" color="gray.500" mt={0.5}>
                {subtext}
              </Text>
            )}
          </Box>
        </Checkbox>
        <Image boxSize={'27px'} src={imageUrl} />
      </Box>
    </Tooltip>
  );
};

export default PaymentMethodCheckbox;
